/**
 * Canonical in-app routes for the Report Center.
 *
 * CC-49980: `/reports` is NOT the reports list. When the Dashboards beta is on
 * (spec 038) `Reports.jsx` treats a bare `/reports` as the Dashboards view —
 * dashboards are the default landing mode and only `?mode=reports` selects the
 * catalog. So every "back to the reports list" fallback has to carry the query,
 * or the user is dropped on Dashboards instead of the list they came from.
 *
 * Harmless when the beta is off: `Reports.jsx` ignores `mode` unless the
 * feature flag AND the per-user opt-in are both enabled.
 *
 * The IQ embed (`/embed/reports`) has dashboards disabled outright and passes
 * its own `backTo` — don't route embed traffic through this constant.
 */
export const REPORTS_LIST_PATH = '/reports?mode=reports'

/**
 * The Report Queue is a REAL route, not a `?mode=` value on `/reports` — it needs
 * deep links (`?jobId=`, `?state=`) and its own back-nav target, which a query
 * mode can't give it. Declared before `reports/:reportId` in App.jsx so "queue"
 * is never parsed as a report id.
 */
export const QUEUE_PATH = '/reports/queue'
export const SCHEDULES_PATH = '/reports/queue/schedules'

export default REPORTS_LIST_PATH
